<template>
  <div>
    <div class="mini-popup-link" @click="openPopup">
      <slot name="linkContent" />
      <div
          :style="{ minWidth: minWidth, minHeight: minHeight }"
          :class="['mini-popup', isOpen ? 'open' : '']">
        <div
            @click.stop="isOpen = false"
            class="close-popup clickable p-1">
          <icon size="0.9" type="close" />
        </div>
        <slot name="popupContent" />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon.vue";
export default {
  name: "MiniPopup",
  components: {Icon},
  props: {
    minWidth: {type: String, default: '300px'},
    minHeight: {type: String, default: '100px'}
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    openPopup() {
      if(!this.isOpen) {
        this.isOpen = true;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.mini-popup-link {
  position: relative;
}
.mini-popup {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--vform-editor-ui-secondary-color);
  border: 1px solid rgba(255,255,255,0.8);
  padding: 15px;
  padding-right: 20px;
  box-shadow: 0 2px 8px rgba(255, 255, 255, 0.15);
  z-index: 1000;
  &.open {
    display: block;
  }
}
.close-popup {
  position: absolute;
  top: 0;
  right: 5px;
  opacity: 0.8;
  transition: all 300ms ease;
  &:hover {
    opacity: 1;
  }
}
</style>